import { render, staticRenderFns } from "./PlatformOwnOfferMarkUpComponent.vue?vue&type=template&id=7aaaadb7&"
import script from "./PlatformOwnOfferMarkUpComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformOwnOfferMarkUpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports